import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { deleteCarLocationSharing as deleteCarLocationSharingOperation } from '../operations/deleteCarLocationSharing';

import { STATUS_LOADING } from 'common/constants';

export const deleteCarLocationSharing = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(deleteCarLocationSharingOperation.pending, (state) => {
    state.locationSharing.deletingStatus = STATUS_LOADING.load;
  })
  .addCase(deleteCarLocationSharingOperation.fulfilled, (state) => {
    state.locationSharing.deletingStatus = STATUS_LOADING.done;
  })
  .addCase(deleteCarLocationSharingOperation.rejected, (state) => {
    state.locationSharing.deletingStatus = STATUS_LOADING.error;
  });